import { ConditionRegistryCategory } from '../../ConditionRegistryCategory';
import { ConditionRegistryQuestionAnsweringState } from './ConditionRegistryQuestionAnsweringState';
import { ConditionRegistryQuestionAspect } from './ConditionRegistryQuestionAspect';
import { ConditionRegistryItem } from '../../ConditionRegistryItem';
import { ConditionRegistryQuestionTask } from './ConditionRegistryQuestionTask';
import { ConditionRegistryQuestionContent } from './ConditionRegistryQuestionContent';
export class ConditionRegistryQuestion extends ConditionRegistryCategory {
    label = 'Frage';
    constructor(parent) {
        super(parent);
        super.init();
    }
    c_a = new ConditionRegistryQuestionAnsweringState(this);
    c_as = new ConditionRegistryQuestionAspect(this);
    c_t = new ConditionRegistryQuestionTask(this);
    c_c = new ConditionRegistryQuestionContent(this);
    isQuestionType = () => new ConditionRegistryItem({
        /*   label: 'Ist Fragetyp',
        params: { core: ['questionTypeName'] }, */
        eval: ({ question, condition }) => !!question && !!condition && question.questionType === condition.local.valueOf.questionTypeName
    });
}
